import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

import { addLocale, replace } from '../misc';
import { Image } from '../design/elements';
import { formCategoryStyle } from './style';
import { useTranslationsContext } from '../context/TranslationsContext';
import request, { adtApiHost, sof1ApiHost } from '../utils/request';
import { adtHomeUrl, sof1HomeUrl } from '../utils/constant';

const FormCategory = ({ category, row, locale, history, isFreezed }) => {
  const {
    name,
    title,
    image,
    description,
    info,
    importantInfo,
    forms,
    platform
  } = category;
  const style = formCategoryStyle(row);
  const addLocaleToUrl = addLocale(locale);
  const translations = useTranslationsContext();

  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { role: { name: roleName = '' } = {} } = userProfile || {};

  const {
    WLS: {
      REPORTING: { reportingHomeButtonTitle, manageDevicesCreditsFee }
    }
  } = translations;

  useEffect(() => {
    if (
      document.getElementById('footer') &&
      document.getElementById('footer').style
    )
      document.getElementById('footer').style.display = 'block';

    if (roleName !== 'ADMIN' && document.getElementById('2')) {
      document.getElementById('2').style.display = 'none';
    }

    if (roleName !== 'ADMIN' && document.getElementById('3')) {
      document.getElementById('3').style.display = 'none';
    }
  }, [roleName]);

  return (
    <div style={style}>
      <div
        className="hidden-xs hidden-sm"
        style={{
          display: 'inline-block',
          margin: '10px 20px 20px 20px',
          verticalAlign: 'top',
          minWidth: '175px'
        }}
      >
        <Image image={image} />
      </div>
      <div style={{ display: 'inline-block', verticalAlign: 'top' }}>
        <div style={{ fontWeight: 'bold' }}>
          <h2>{title}</h2>
        </div>
        <div style={{ color: '#999999' }}>
          <span className="frg-body-font-14px">
            {description && (
              <span style={{ color: '#49166d', fontWeight: '400' }}>
                {description}
              </span>
            )}
            {info && (
              <>
                <br />
                {info}
              </>
            )}
            {importantInfo && (
              <>
                <br />
                <b>
                  <span style={{ color: '#C12335' }}>{importantInfo}</span>
                </b>
              </>
            )}
          </span>
        </div>

        {forms && (
          <div style={{ paddingTop: '20px' }}>
            {forms.map((form, index) => {
              const key = `form${index}`;
              const url = addLocaleToUrl(
                `/${replace(name)}/${replace(form.fields.name)}`
              );

              return (
                !form.fields.hideOnDashboard && (
                  <Fragment key={key}>
                    <span>
                      <button
                        type="button"
                        disabled={isFreezed}
                        id={index}
                        onClick={() => {
                          if (platform === 'SOF1') {
                            window.location.replace(
                              request.getSSOLoginState()
                                ? `${sof1ApiHost}/users/sso-login?url=${JSON.stringify(
                                    {
                                      title,
                                      name,
                                      formField: form.fields
                                    }
                                  )}`
                                : sof1HomeUrl
                            );
                          } else if (platform === 'ADT') {
                            window.location.replace(
                              request.getSSOLoginState()
                                ? `${adtApiHost}/users/sso-login`
                                : adtHomeUrl
                            );
                          } else if (
                            form.fields.title === manageDevicesCreditsFee
                          ) {
                            history.push('/upload-hardware-grid');
                          } else history.push(url);
                        }}
                        className={
                          'frg-button' +
                          `${
                            form.fields.title === reportingHomeButtonTitle ||
                            form.fields.title === manageDevicesCreditsFee
                              ? ' color-purple'
                              : ' color-green'
                          }`
                        }
                      >
                        {form.fields.title}
                      </button>
                    </span>
                    &nbsp;
                  </Fragment>
                )
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

FormCategory.propTypes = {
  category: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    image: PropTypes.objectOf(PropTypes.object),
    description: PropTypes.string,
    info: PropTypes.string,
    importantInfo: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    forms: PropTypes.arrayOf(PropTypes.object),
    platform: PropTypes.string
  }),
  row: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    go: PropTypes.func
  }).isRequired,
  isFreezed: PropTypes.bool
};

FormCategory.defaultProps = {
  category: null,
  isFreezed: false
};

export default FormCategory;
